import { BoxSlotTypeOf } from "@/modules/boxSlot/boxSlotTypes"
import { ProgramType } from "@/modules/programs/types/programTypes"
import { SessionTypeOf } from "@/modules/sessions/programSessionTypes"
import {
  TrainingBoxSlotEntity,
  TrainingProgramInfiniteSessionEntity,
  TrainingProgramOnOffSessionEntity,
} from "@/modules/training/entities/trainingContentItemEntity"
import type { OnOffSessionItemDto, TrainingItemDto } from "@/modules/training/gateway/trainingDto"

export type TrainingItemSessionEntity = {
  type: typeof SessionTypeOf
  content: TrainingProgramInfiniteSessionEntity | TrainingProgramOnOffSessionEntity
}

export type TrainingItemBoxSlotEntity = {
  type: typeof BoxSlotTypeOf
  content: TrainingBoxSlotEntity
}

export type TrainingItemEntityType = TrainingItemSessionEntity | TrainingItemBoxSlotEntity

export const TrainingItemEntityFactory = {
  fromDto: (dto: TrainingItemDto): TrainingItemEntityType => {
    if (dto.type === SessionTypeOf) {
      return {
        type: dto.type,
        content:
          dto.content.programType === ProgramType.VIRTUAL || dto.content.programType === ProgramType.PRO
            ? TrainingProgramInfiniteSessionEntity.fromDto(dto.content)
            : TrainingProgramOnOffSessionEntity.fromDto(dto.content as OnOffSessionItemDto),
      }
    }
    if (dto.type === BoxSlotTypeOf) {
      return {
        type: dto.type,
        content: TrainingBoxSlotEntity.fromDto(dto.content),
      }
    }
    throw new Error(`Invalid training content type: ${JSON.stringify(dto)}`)
  },
}
